import { getConstant } from '../utils';

export const getCalculatorsDepth = getConstant('GET_CALCULATORS_DEPTH');
export const getCalculatorsDepthItem = getConstant('GET_CALCULATORS_DEPTH_TYPE');